import { FuncResponse, FuncResponseType, FunctionBase, RunStreamResponse, } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import isBlank from "@sedan-utils/is-blank";
export class AskBrainFunction extends FunctionBase {
    constructor(brainClient, authStore, meStore, messageCenter, topicService) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.meStore = meStore;
        this.messageCenter = messageCenter;
        this.topicService = topicService;
    }
    async run(input, identityInfo) {
        const streaming = await this.meStore.hasAskBrainStreamingPermission();
        const socket = await this.meStore.hasAskBrainSocketPermission();
        const streamResponse = new RunStreamResponse();
        let messageCenter;
        let getRealData = false;
        let topic = "";
        let socketPromise = new Promise(resolve => resolve());
        if (socket) {
            topic = await this.topicService.generateTopic(identityInfo, "ask_brain");
            // socketPromise = new Promise(resolve => {
            //   this.messageCenter?.on("authenticated", (res: any) => {
            //     resolve();
            //   });
            // });
            this.messageCenter.on(topic, (res) => {
                const answer = res.message;
                if (getRealData === false) {
                    streamResponse.receive(answer, false);
                }
            });
        }
        await socketPromise;
        if (streaming) {
            let onReceived = (msg) => {
                if (msg.done) {
                    msg.abort();
                }
                messageCenter?.off(topic, () => { });
                getRealData = true;
                const fullText = msg.fullText.trim();
                streamResponse.receive(fullText, msg.done);
            };
            this.brainClient.openAi
                .askBrain(input, isBlank(topic) ? undefined : topic, FunctionUtil.createAbortUuid(identityInfo))
                .then(re => {
                re.onReceived(re => onReceived(re));
            })
                .catch(error => {
                messageCenter?.off(topic, () => { });
                getRealData = true;
                streamResponse.receive("", true, error);
            });
            return new FuncResponse(FuncResponseType.ASK_BRAIN, streamResponse);
        }
        const res = this.brainClient.openAi
            .askBrainAnswer(input, isBlank(topic) ? undefined : topic, FunctionUtil.createAbortUuid(identityInfo))
            .then(res => {
            messageCenter?.off(topic, () => { });
            getRealData = true;
            streamResponse.receive(res.data, true);
        })
            .catch(error => {
            messageCenter?.off(topic, () => { });
            getRealData = true;
            streamResponse.receive("", true, error);
        });
        return new FuncResponse(FuncResponseType.ASK_BRAIN, streamResponse);
    }
}
